export default __webpack_public_path__ + "static/media/searchIcon.a5b5dc32.svg";